module.exports = __webpack_public_path__ + "img/default-avatar.be0a76e4.png";